const required = (name: string, value: string | undefined): string => {
  if (!value) {
    console.warn(`[config] Missing ${name} — set it in .env.local`);
  }
  return value ?? "";
};

export const config = {
  // auth-core WhatsApp-OTP login (same mechanism as plan-migration.vammo.com):
  // we redirect there with ?redirectUrl= and come back with ?token=<jwt>.
  authUrl: required("VITE_AUTH_URL", import.meta.env.VITE_AUTH_URL),
  // ms-taffarel gateway base (it injects X-User-Id from the JWT for
  // /v1/rto-migration/* and proxies /v1/rto-contract* to leoparda).
  apiUrl: required("VITE_API_URL", import.meta.env.VITE_API_URL),
};
